export enum Product {
    Account = 'Account',
    Authenticator = 'Authenticator',
    Mail = 'Mail',
    Calendar = 'Calendar',
    Wallet = 'Wallet',
    Docs = 'Docs',
    Sheets = 'Sheets',
    Lumo = 'Lumo',
    Drive = 'Drive',
    VPN = 'VPN',
    Verify = 'VPN',
    Admin = 'Admin',
    Pass = 'Pass',
    Meet = 'Meet',
    Spaces = 'Spaces',
    Other = 'Other',
}
